// src/auth/RedirectIfLoggedIn.js
import { Navigate, Outlet } from "react-router-dom";

const RedirectIfLoggedIn = () => {
  const token = sessionStorage.getItem("token");
  return token ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default RedirectIfLoggedIn;
